// Reemplazar este link por el link real de checkout (MercadoPago, Hotmart, etc.)
// Opción 1: El Arsenal del Nutri base ($19.990)
export const CHECKOUT_URL =
  'https://el-arsenal-del-nutri.impultienda.ar/checkout'

// Opción 2: El Arsenal del Nutri + 3 Especializaciones ($29.990)
export const CHECKOUT_URL_PLUS =
  'https://el-arsenal-del-nutri.impultienda.ar/checkout'

export const scrollToBuy = (e?: React.MouseEvent) => {
  if (e) e.preventDefault()
  // Cada vez que un CTA lleva a la sección de pagos, dejamos seleccionada
  // la opción "Arsenal + 3 Especializaciones".
  window.dispatchEvent(new CustomEvent('select-plus-plan'))
  const element = document.getElementById('comprar')
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' })
  }
}
